import { EnvironmentType } from "./environment-types";

export const environment = {
  production: false,
  baseUrl: 'https://dev-api-formops.vallift.com',
  environment: EnvironmentType.DEVELOPMENT,
  googleMapsApiKey:'AIzaSyAJudCpZsKMTAf4Et-Xq2bXbB49fdfT_hw'
};
